import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client'

import { store }  from '@/store'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [], // no types provided
    },
  },
});

const cache = new InMemoryCache({ fragmentMatcher })

// Install the vue plugin
Vue.use(VueApollo)

// const httpLink = new HttpLink({
//   // You should use an absolute URL here
//   uri: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'
// })

const uploadLink = createUploadLink({ uri: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql' });

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      authorization: localStorage.getItem('token') || "",
    }
  });

  return forward(operation);
})

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

// Create the apollo client
export const apolloClient = new ApolloClient({
  
  link: concat(authMiddleware, uploadLink),
  cache,
  defaultOptions: defaultOptions,
  connectToDevTools: true,

   onError: ({ graphQLErrors, networkError }) => {

    if (networkError) {
      console.log("[networkError]", networkError);
      store.dispatch("signoutUser");
    }

    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        console.dir(err);
        if (err.name === "AuthenticationError") {
          // set auth error in state (to show in snackbar)
          store.commit("setAuthError", err);
          // signout user (to clear token)
          store.dispatch("signoutUser");
        }
      }
    }
  }

})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})


export default apolloProvider